import { axiosInstance } from "api/axios.instance"
import type { AxiosResponse } from "axios"
import type { TCustomModelNumber, TCustomModelNumberPayload } from "types/customModelNumbers.type"

class CustomModelNumbersService {
	private endpoint(drawingId: number) {
		return `drawings/${drawingId}/custom-model-numbers/`
	}

	async getCustomModelNumbers(drawingId: number): Promise<AxiosResponse<TCustomModelNumber[]>> {
		return axiosInstance.get(this.endpoint(drawingId))
	}

	async createCustomModelNumber(
		drawingId: number,
		payload: TCustomModelNumberPayload,
	): Promise<AxiosResponse<TCustomModelNumber>> {
		return axiosInstance.post(this.endpoint(drawingId), payload)
	}

	async updateCustomModelNumber(
		drawingId: number,
		customModelNumberId: number,
		payload: TCustomModelNumberPayload,
	): Promise<AxiosResponse<TCustomModelNumber>> {
		return axiosInstance.patch(`${this.endpoint(drawingId)}${customModelNumberId}/`, payload)
	}

	async deleteCustomModelNumber(drawingId: number, customModelNumberId: number): Promise<void> {
		await axiosInstance.delete(`${this.endpoint(drawingId)}${customModelNumberId}/`)
	}
}

export default new CustomModelNumbersService()
